import React from 'react';
import { Box, Chip } from '@mui/joy';

export default function InterestChips({ interests }) {
    const colors = ['primary', 'neutral', 'success', 'danger', 'warning', 'info'];

    return (
        <Box 
        sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            flexWrap: 'wrap', // allows chips to wrap on smaller screens
            gap: 1, // sets spacing between chips
            // paddingTop: '10px', // optional padding for the box itself
        }}
        // display="flex" alignItems="center" pt={2}
        // sx={{"display":"flex","justifyContent":"center", padding:'0.1', overflowX: 'auto'}}
         >
            {interests.sort().map((interest, index) => {

                return (
                    <Chip key={interest} size='sm' color={colors[index]} sx={{ fontWeight: 'bold', margin:'2px' }}>
                        {interest}
                    </Chip>
                );
            })}
        </Box>
    );
}
